import Collapse from './Collapse';
export default Collapse;
//# sourceMappingURL=index.js.map
